import React, { useState } from "react";

import FilterContainer from "../../../../components/common/FilterContainer";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import MultiSelect from "../../../../components/common/MultiSelect";

import {
  Button,
  Form,
  Row,
  Col,
  Select,
  Space,
  DatePicker,
  InputNumber,
  Table,
} from "antd";

import { glAccounts, payers, receiptsTableData } from "../../../../data/accounting";
import { Propertiesunitscampaigns } from "../../../../data/renewals";

import { FaDollarSign } from "react-icons/fa";

import "./Payments.css";
import TreeMultiSelect from "../../../../components/common/TreeSelect";
import { useNavigate } from "react-router-dom";

const ReceivablePaymentsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [


    RightBarMethod("Tenant Receipt", "1", "", "", "/accounting/receivables_payments/reciepts/tenant_receipts/new"),
    RightBarMethod("Homeowner Receipt", "2", "", "", "/accounting/receivables_payments/reciepts//HomeownerReceipt"),
    RightBarMethod("Other Receipt", "3", "", "", "/accounting/receivables_payments/reciepts/otherReceipt"),
    RightBarMethod("Subsidy Receipt", "4", "", "", "/accounting/receivables_payments/reciepts/subsidyreceipt"),
    RightBarMethod("Application Fee", "5", "", "", "/accounting/receivables_payments/reciepts/newapplicationfee"),
    RightBarMethod("Bulk Charges & Credits", "8", "", "", "/accounting/receivables_payments/invoices/bulkchargesandcredits"),
    RightBarMethod("Tenant Charge", "6", "", "", "/accounting/receivables_payments/invoices/tenantcharge"),
    RightBarMethod("Homeowner Charge", "7", "", "", "/accounting/receivables_payments/invoices/homeownercharge"),
    RightBarMethod("Bulk Recurring Charges", "9", "", "", "/accounting/receivables_payments/invoices/bulkrecurringcharges"),
    RightBarMethod("Tenant Credit", "10", "", "", "/accounting/receivables_payments/invoices/newtenantcredit"),
    RightBarMethod("Homeowner Credit", "11", "", "", "/accounting/receivables_payments/invoices/newhomeownercredit"),
    RightBarMethod("Apply Credits", "12", "", "", "/accounting/receivables_payments/reciepts/applycredits"),
    RightBarMethod("Common Charge", "13", "", "", "/accounting/receivables_payments/invoices/NewCommonCharge"),
    RightBarMethod("Charge Late Fees", "14", "", "", "/accounting/receivables_payments/chargelatefees"),
    RightBarMethod("New Bank Deposit", "15", "", "", "/accounting/receivables_payments/bank_deposits/NewBankDeposit"),
    RightBarMethod("Lockbox", "16", "", "", "/accounting/receivables_payments/lockbox"),
  ]),

  RightBarMethod(
    " HELP TOPICS",
    "t2",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Tenant Online Payments", "17", "", "", "/")]
  ),
];

function Payments() {
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };
  const navigate = useNavigate();

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => a.date.length - b.date.length,
      sortOrder: sortedInfo.columnKey === "date" ? sortedInfo.order : null,
    },
    {
      title: "Payer",
      dataIndex: "payer",
      key: "payer",
      sorter: (a, b) => a.payer.length - b.payer.length,
      sortOrder: sortedInfo.columnKey === "payer" ? sortedInfo.order : null,
    },
    {
      title: "GL Account",
      dataIndex: "glAccount",
      key: "glAccount",
      sorter: (a, b) => a.glAccount.length - b.glAccount.length,
      sortOrder: sortedInfo.columnKey === "glAccount" ? sortedInfo.order : null,
    },
    {
      title: "Property-Unit",
      width: 150,
      dataIndex: "propertyUnit",
      key: "propertyUnit",
      sorter: (a, b) => a.propertyUnit.length - b.propertyUnit.length,
      sortOrder:
        sortedInfo.columnKey === "propertyUnit" ? sortedInfo.order : null,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount.length - b.amount.length,
      sortOrder: sortedInfo.columnKey === "amount" ? sortedInfo.order : null,
    },
    {
      title: "Reference",
      dataIndex: "reference",
      key: "reference",
      sorter: (a, b) => a.reference.length - b.reference.length,
      sortOrder: sortedInfo.columnKey === "reference" ? sortedInfo.order : null,
    },
  ];
  return (
    <>
    {/* <Outlet /> */}
      <div className="receipts">
        <PageHeading heading="Receipts" />
        <Row>
          <Col span={24}>
            <FilterContainer
              heading={"Filter receipts with the options below."}
            >
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Properties">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by property, group, portfolio, or owner"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Units">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by units"
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Select
                        options={[
                          { value: "Show Active Properties" },
                          { value: "Show All Properties" },
                          { value: "Show Hidden Properties" },
                        ]}
                        defaultValue="Show Active Properties"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Payers">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by Payers"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="GL Accounts">
                      <TreeMultiSelect
                        options={[]}
                        placeholder="Select GL Account"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Amount">
                      <InputNumber
                        placeholder="Amount"
                        addonBefore={<FaDollarSign size={12} />}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="From" required>
                      <Row justify="space-between" align="middle">
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                        <Col>
                          <span>To</span>
                        </Col>
                        <Col>
                          <Space direction="vertical">
                            <DatePicker />
                          </Space>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        <Row>
          <Col className="table-container" span={24}>
            <Table
              columns={columns}
              dataSource={[]}
              onChange={handleChange}
              onRow={(record) => {
                return {
                  onClick: () =>
                    navigate(
                      `/accounting/receivables_payments/reciepts/${record.id}`
                    ),
                };
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ReceivablePaymentsRightBar} />
      </div>
    </>
  );
}

export default Payments;
